import { FRAGMENT_ANNOTATION_BODY } from '@gitbook/doc-core';
import { isBlockRangeSelection } from '@gitbook/slate';
import type { Plugin } from '@gitbook/slate-react';

import { isEscape, isModEnter } from '../common';

/**
 * Plugin to exit annotation when pressing Mod+Enter or Escape.
 */
export const plugin: Plugin = {
    onKeyDown: (event, change) => {
        if (isBlockRangeSelection(change.value.selection)) {
            return;
        }

        if (isModEnter(event) || isEscape(event)) {
            const { value } = change;
            const { startBlock, document } = value;

            if (!startBlock) {
                return;
            }

            // If the mentions picker is opened we want to close it on `Escape`
            // but keep focus in the annotation editor so user can keep editing it.
            const text = startBlock.getText();
            const textHasMention = text.includes('@') || text.includes('#');
            if (textHasMention) {
                event.preventDefault();
                return change;
            }

            const fragment = document.getFragmentParent(startBlock.key);
            if (fragment?.object !== 'fragment' || fragment.type !== FRAGMENT_ANNOTATION_BODY) {
                return;
            }

            const inline = document.getParent(fragment.key);
            if (!inline) {
                return;
            }
            change.collapseToEndOf(inline);
            return change;
        }
    },
};
